AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Search");

AoPS.Ebooks.Views.Search = (function (EbkVSearch) {
	// Dependencies
	var EbkVBase = AoPS.Ebooks.Views.Base;

	EbkVSearch.SearchInput = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-search-input");

			this.is_free_preview = options.is_free_preview;

			this.render();
		},

		getContext: function () {
			return {
				placeholder: "Search Index",
			};
		},

		postRender: function () {
			this.setupAutocomplete();
			this.setupResultsVisibility();
		},

		setupAutocomplete: function () {
			var book = this.model;
			var self = this;
			var input = this.$(".ebk-search-input input");

			if (this.is_free_preview) {
				input.on("change", function () {
					input.val("");
					EbkVBase.showFreePreviewModal("preview-search", book);
				});
				return;
			}

			input.aopsAutocomplete({
				delay: 1000,
				minLength: 2,
				source: function (request, response) {
					book.findSearchMatches(request.term, function (ok, data) {
						if (!ok) {
							return self.onAjaxError(data);
						}
						response(_.compact(_.map(data, self.makeMatchFromData, self)));
					});
				},
				onSelect: function (event, data) {
					book.findSearchResults(data.item.value, function (ok, search_data) {
						if (!ok) {
							return self.onAjaxError(search_data);
						}
						self.displayResults(search_data);
					});
				},
			});
		},

		// Behavior governing when the search results are visible is
		// complicated, and almost all put in here.
		setupResultsVisibility: function () {
			var search_input = this.$(".ebk-search-input input");
			var search_results = this.$(".ebk-search-results");

			// Hide initially
			search_results.hide();

			// Change the search term? Hide.
			search_input.on("input", function () {
				search_results.hide();
			});

			// The remaining conditions to hide the results are:
			// - the input has been blurred since the last time results were shown.
			// - the mouse is not currently hovering over the results.

			this.is_mouse_over_results = false;
			// Should be reset to false each time results are shown.
			this.is_search_blurred = false;

			// _.bind would be a huge pain here, so let's just do this.
			var self = this;

			function updateResultsVis() {
				if (!self.is_mouse_over_results && self.is_search_blurred) {
					search_results.hide();
					self.is_mouse_over_results = false;
				}
			}

			// Track if mouse is hovering over results
			search_results
				.mouseenter(function () {
					self.is_mouse_over_results = true;
				})
				.mouseleave(function () {
					self.is_mouse_over_results = false;
					updateResultsVis();
				});

			// Track if search input is blurred/unfocused
			search_input.on("blur", function () {
				self.is_search_blurred = true;
				updateResultsVis();
			});
		},

		cleanEntry: function (entry) {
			// Forget displaying entries with LaTeX in them
			if (/\$/.test(entry)) {
				return null;
			}
			// Convert the LaTeX index ! symbol to a colon
			return entry.replace(/!(\S)/g, ": $1");
		},

		// Given an object with entry and count keys (count being
		// number of appearances of entry in book), compute an object with value
		// and label keys for handing to jquery autocomplete control.
		makeMatchFromData: function (data) {
			var clean_entry = this.cleanEntry(data.entry);
			if (!clean_entry) {
				return null;
			}

			var count_suffix = " (" + data.count + ")";
			if (!data.count || data.count <= 1) {
				count_suffix = "";
			}
			return {
				value: data.entry,
				label: clean_entry + count_suffix,
			};
		},

		onAjaxError: function (data) {
			EbkVBase.showModalError(
				"A problem occurred while fetching the results of your search.",
				data
			);
			var search_input = this.$(".ebk-search-input input");
			var search_results = this.$(".ebk-search-results");
			search_input.val("");
			search_input.blur();
			search_results.hide();
		},

		// If a one-element array is passed, automatically goes to that URL.
		displayResults: function (results) {
			var book = this.model;

			function gotoSearch(loc) {
				var details = _.clone(loc);
				delete details.section_id;
				Backbone.trigger("ebk_goto_section", book, loc.section_id, details);
			}

			if (results.length === 1) {
				gotoSearch(results[0]);
			}

			var result_els = _.map(
				results,
				function (loc) {
					var section = book.get("sections").get(loc.section_id);
					if (!section) {
						return "";
					}

					var result = $(
						$.parseHTML(
							'<div class="ebk--item ebk-one-line ebk-pointer">' +
								section.getNumberTitle() +
								"</div>"
						)
					);
					result.click(function () {
						gotoSearch(loc);
					});

					return result;
				},
				this
			);

			this.$(".ebk-search-results").empty().append(result_els).show();

			// See setupResultsVisibility for purpose of this line.
			this.is_search_blurred = false;
		},
	});

	return EbkVSearch;
})(AoPS.Ebooks.Views.Search);
